import React, { useEffect, useState } from "react";
import styles from "./FacilityDetails.module.scss";
import noImg from "../../../assets/noImage.jpeg";
import Loader from "../../../components/Loader/Loader";
const FacilityDetails = () => {
  const [facilityData, setFacilityData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFacilityDetails = async () => {
      const token = localStorage.getItem("access_token");
      try {
        const response = await fetch(
          "https://ballersapi.ballerslife.co/api/v1/facility_admin/get_facility_details",
          {
            method: "GET",
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        setFacilityData(data);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchFacilityDetails();
  }, []);

  if (error) return <div>Error: {error}</div>;
  if (!facilityData) return <Loader />;

  const {
    facility_id,
    facility_name,
    club_timings,
    city,
    locality,
    country,
    direction_link,
    available_sports,
    facility_type,
    facility_contact,
    sport_info,
  } = facilityData;

  return (
    <div className={styles.facilityContainer}>
      <div className="clubLogoMain">
        {/* <img
          src={facilityData.facility_image}
          alt="Facility Logo"
          className="clubLogo"
        /> */}
        {facilityData.facility_image == null ? (
          <img
            src={noImg}
            alt="Facility Logo"
            className="clubLogo"
            style={{ width: "100px", height: "100px" }}
          />
        ) : (
          <img
            src={facilityData.facility_image}
            alt="Facility Logo"
            className="clubLogo"
          />
        )}
      </div>
      <div className={styles.details}>
        <div className={styles.infoSection}>
          <p>
            <strong className="faDTitle">Facility ID:</strong> {facility_id}
          </p>
          <p>
            <strong className="faDTitle">Facility Name:</strong> {facility_name}
          </p>
          <p>
            <strong className="faDTitle">Club Timings:</strong> Mon-Fri,{" "}
            {club_timings["Mon-Fri"].start_time} -{" "}
            {club_timings["Mon-Fri"].close_time}, Sat-Sun,{" "}
            {club_timings["Sat-Sun"].start_time} -{" "}
            {club_timings["Sat-Sun"].close_time}
          </p>
          <p>
            <strong className="faDTitle">City:</strong> {city}
          </p>
          <p>
            <strong className="faDTitle">Locality:</strong> {locality}
          </p>
          <p>
            <strong className="faDTitle">Country:</strong> {country}
          </p>
          <p>
            <strong className="faDTitle">Direction Link:</strong>{" "}
            <a href={direction_link} target="_blank" rel="noopener noreferrer">
              View Map
            </a>
          </p>
          <p>
            <strong className="faDTitle">Available Sports:</strong>{" "}
            {available_sports.join(", ")}
          </p>
          <p>
            <strong className="faDTitle">Facility Type:</strong> {facility_type}
          </p>
          <p>
            <strong className="faDTitle">Facility Contact:</strong>{" "}
            {facility_contact}
          </p>
        </div>
        <div className={styles.sportInfo}>
          <h4>Sport Info:</h4>
          {Object.entries(sport_info).map(([sport, details]) => (
            <div key={sport}>
              <p>
                <strong>
                  {sport.charAt(0).toUpperCase() + sport.slice(1)}:
                </strong>{" "}
                {details.num_of_courts} courts, Min Players:{" "}
                {details.min_players}, Max Players: {details.max_players}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FacilityDetails;
